import React, { Component } from "react";
import RecoverPasswordDialog from "../../../components/auth/RecoverPassword";
import { connect } from "react-redux";
import { recoverPassword } from "../../../store/users/operations";
import { isUpdatingUser } from "../../../store/users/selectors";
import RecoverPasswordValidators from "./validators";
import { navigate } from "../../../store/navigation/operations";

export class RecoverPassword extends Component {
  render() {
    return (
      <div>
        <RecoverPasswordDialog
          isOpen={true}
          isLoading={this.props.loading}
          onClose={() => {
            this.props.navigate("/");
          }}
          validators={RecoverPasswordValidators}
          onRecoverPassword={u_name => {
            this.props.recoverPassword(u_name, "/");
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  locale: state.i18n.locale,
  loading: isUpdatingUser(state)
});

const mapDispatchToProps = dispatch => ({
  navigate: to => dispatch(navigate(to)),
  recoverPassword: (payload, redirectTo) => dispatch(recoverPassword(payload, redirectTo))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecoverPassword);
